import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { appVariables } from '../app.constants';

@Injectable()
export class featurePolicyInterceptor implements HttpInterceptor {

  public constructor() {
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const featurePolicy = req.headers.get('Feature-Policy');
    // let clonedRequest: HttpRequest<any>;

    // Clone the request and set the new header.
    if (featurePolicy) {
      req = req.clone({headers: req.headers.set('Feature-Policy', featurePolicy)});
      // clonedRequest = req.clone({
      //   setHeaders: {client_id: clientId, client_secret: clientSecret, 'Feature-Policy': featurePolicy}
      // });
    } else {
      req = req.clone({headers: req.headers.set('Feature-Policy', appVariables.defaultfeaturePolicyHeader)});
    }

    // send cloned request with header to the next handler.
    return next.handle(req);
  }
}
